import { useEffect, useState } from "react";
import {
  Box,
  Button,
  Flex,
  Heading,
  Image,
  Modal,
  ModalContent,
  ModalOverlay,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  useColorModeValue,
  Tabs,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { TbDiamond } from "react-icons/tb";
import SidebarWithHeader from "components/SidebarWithHeader";
import UploadImageModal from "components/aiHub/uploadImageModal";
import UploadVideoAvatarModal from "components/aiHub/uploadVideoAvatarModal";
import UploadVideoProductModal from "components/aiHub/uploadVideoProductModal";
import { useGetRemainingCredsQuery } from "store/aiHub/aiGenerationApi";
import { useImageUsageQuery, useVideoUsageQuery } from "store/Subscription/PlanUsageApi";
import { useNavigate, useSearchParams } from "react-router-dom";
import OutputGenerated from "components/aiHub/OutputGenerated";

function AiHub() {
  const tabSelectedText = useColorModeValue("white", "brand.900");
  const navBackground = useColorModeValue("purple.500", "brand.500");
  const textColor = useColorModeValue("brand.900", "brand.500");
  const textColorSub = useColorModeValue("brand.300", "brand.700");
  const navigate = useNavigate();

  const {
    isOpen: isImageModalOpen,
    onOpen: onImageModalOpen,
    onClose: onImageModalClose,
  } = useDisclosure();
  const {
    isOpen: isVideoModalOpen,
    onOpen: onVideoModalOpen,
    onClose: onVideoModalClose,
  } = useDisclosure();

  const [videoType, setVideoType] = useState("");

  // --- URL state (persist tabs) ---
  const [searchParams, setSearchParams] = useSearchParams();

  const getInitialMainTab = () => (searchParams.get("tab") === "videos" ? "videos" : "images");
  const getInitialVideoSubTab = () => searchParams.get("vtab") === "rendered" ? "rendered" : "generate";

  const [selectedTab, setSelectedTab] = useState(getInitialMainTab());
  const [videoSubTab, setVideoSubTab] = useState(getInitialVideoSubTab());

  // Keep URL in sync when local state changes
  const updateSearch = (tab, vtab) => {
    const params = new URLSearchParams(searchParams);
    params.set("tab", tab);
    if (tab === "videos") {
      params.set("vtab", vtab || "generate");
    } else {
      params.delete("vtab");
    }
    setSearchParams(params, { replace: true });
  };

  useEffect(() => {
    updateSearch(selectedTab, videoSubTab);
  }, [selectedTab, videoSubTab]);

  // Respond to browser back/forward navigation updates to the URL
  useEffect(() => {
    const urlTab = getInitialMainTab();
    const urlVTab = getInitialVideoSubTab();
    if (urlTab !== selectedTab) setSelectedTab(urlTab);
    if (urlVTab !== videoSubTab) setVideoSubTab(urlVTab);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams.toString()]);

  const {
    data: remainingCreds,
    isLoading: isRemainingCredsLoading,
    isError,
  } = useGetRemainingCredsQuery();

  // const { data: imageUsage, isLoading: isImagesUsageLoading, refetch: imageUsageRefetch } = useImageUsageQuery({
  //   },{ skip: selectedTab !== "images"}
  // );

  // const { data: videoUsage, isLoading: isVideosUsageLoading, refetch: videoUsageRefetch} = useVideoUsageQuery({
  //   },{ skip: selectedTab !== "videos"}
  // );

  // const {
  //   data: videoUsage,
  //   isLoading: isVideosUsageLoading,
  //   refetch: videoUsageRefetch,
  // } = useVideoUsageQuery({}, { skip: selectedTab !== "videos" });

  const handleMediaTypeChange = (value, type = "") => {
    setVideoType(type);
    if (value === "image") {
      onImageModalOpen();
    } else {
      onVideoModalOpen();
    }
  };

  const handleUploadSuccess = async () => {
    // imageUsageRefetch();
  };

  return (
    <SidebarWithHeader>
      <Flex
        direction={["column", "row"]}
        justifyContent="space-between"
        alignItems={["flex-start", "center"]}
        gap={[3, 0]}
        flexWrap="wrap"
      >
        <Heading as="h1" size="xl" color={textColor}>
          AI Hub
        </Heading>

        {/* <Flex
          direction={["column", "row"]}
          gap={[2, 2]} // keep small gap even in row mode
          alignItems={["flex-start", "center"]}
          mt={[2, 0]}
        >
          {selectedTab === "videos" ? (
            <Button
              leftIcon={<TbDiamond boxSize={3} />}
              variant="outline"
              colorScheme="brand"
              size="sm"
              borderRadius="lg"
              isLoading={isVideosUsageLoading}
              onClick={() => navigate("/subscription")}
            >
              {`${videoUsage?.video?.remaining ?? 0} credits | upgrade`}
            </Button>
          ) : selectedTab === "images" ? (
            <>
              <Button
                leftIcon={<TbDiamond boxSize={3} />}
                variant="outline"
                colorScheme="brand"
                size="sm"
                borderRadius="lg"
                isLoading={isImagesUsageLoading}
                onClick={() => navigate("/subscription")}
              >
                {`${imageUsage?.background?.remaining ?? 0} Background credits`}
              </Button>

              <Button
                leftIcon={<TbDiamond boxSize={3} />}
                variant="outline"
                colorScheme="brand"
                size="sm"
                borderRadius="lg"
                isLoading={isImagesUsageLoading}
                onClick={() => navigate("/subscription")}
              >
                {`${imageUsage?.variation?.remaining ?? 0} Variation credits`}
              </Button>
            </>
          ) : null}
        </Flex> */}
      </Flex>

      <Box mt="20px">
        <Tabs
          colorScheme="brand"
          variant="solid-rounded"
          size="sm"
          position="relative"
          index={selectedTab === "images" ? 0 : 1}
          onChange={(index) => {
            const newTab = index === 0 ? "images" : "videos";
            setSelectedTab(newTab);
            // When switching to videos, keep current vtab (or default to generate)
            if (newTab === "videos" && !videoSubTab) {
              setVideoSubTab("generate");
            }
          }}
          isLazy
        >
          <Flex justify="space-between">
            <TabList gap="10px">
              <Tab
                borderWidth={1}
                borderRadius={5}
                colorScheme="brand"
                border={textColor}
                fontWeight="light"
                _selected={{ color: tabSelectedText, bg: navBackground }}
              >
                Images
              </Tab>
              <Tab
                borderWidth={1}
                borderRadius={5}
                colorScheme="brand"
                border={textColor}
                _selected={{ color: tabSelectedText, bg: navBackground }}
                fontWeight="light"
              >
                Videos
              </Tab>
            </TabList>
          </Flex>

          <TabPanels minHeight="435px">
            {/* ===== Images Tab ===== */}
            <TabPanel p={0}>
              <Flex
                direction="column"
                alignItems="center"
                justifyContent="space-between"
                p={[4, 6, 10]}
                width="100%"
                gap={[6, 8, 20]}
              >
                <Flex gap={[6, 8, 10]} width="100%" justifyContent="space-around" flexWrap="wrap">
                  {/* Image + Caption 1 */}
                  <Flex
                    direction="column"
                    align="center"
                    gap={4}
                    flex="1 1 300px"
                    maxW="380px"
                    borderColor="brand.800"
                    border="1px solid"
                    p={[4, 6]}
                    borderRadius="7%"
                  >
                    <Flex
                      justify="center"
                      alignItems="center"
                      width="100%"
                      maxW="330px"
                      height="auto"
                      style={{ aspectRatio: 1 }}
                      overflow="hidden"
                    >
                      <Image
                        src="/BG change_2.gif"
                        alt="Image Generation Steps"
                        width="100%"
                        height="100%"
                        borderRadius="10px"
                      />
                    </Flex>
                    <Flex direction="column" gap={1}>
                      <Text fontSize="md" fontWeight="bold">
                        Background Variation
                      </Text>
                      <Text fontSize="12px">
                        Generate backgrounds for your products and see them in new environments with AI.
                      </Text>
                      <Flex justify="center" width="100%" mt={2}>
                        <Button width="150px" size="sm" colorScheme="brand" onClick={() => handleMediaTypeChange("image")}>
                          Start
                        </Button>
                      </Flex>
                    </Flex>
                  </Flex>

                  {/* Image + Caption 2 */}
                  <Flex
                    direction="column"
                    align="center"
                    gap={4}
                    flex="1 1 300px"
                    maxW="380px"
                    borderColor="brand.800"
                    border="1px solid"
                    p={[4, 6]}
                    borderRadius="7%"
                  >
                    <Flex
                      justify="center"
                      alignItems="center"
                      width="100%"
                      maxW="330px"
                      height="auto"
                      style={{ aspectRatio: 1 }}
                      overflow="hidden"
                    >
                      <Image
                        src="/Full Change_2.gif"
                        alt="Image Generation Steps"
                        width="100%"
                        height="100%"
                        borderRadius="10px"
                      />
                    </Flex>
                    <Flex direction="column" gap={1}>
                      <Text fontSize="md" fontWeight="bold">
                        Creative Variation
                      </Text>
                      <Text fontSize="12px">
                        Generate entirely new images using AI, including both the product and the setting it’s placed in.
                      </Text>
                      <Flex justify="center" width="100%" mt={2}>
                        <Button width="150px" size="sm" colorScheme="brand" onClick={() => handleMediaTypeChange("image")}>
                          Start
                        </Button>
                      </Flex>
                    </Flex>
                  </Flex>
                </Flex>
              </Flex>
            </TabPanel>

            {/* ===== Videos Tab ===== */}
            <TabPanel p={0}>
              {/* Sub-tabs under Videos */}
              <Tabs
                colorScheme="brand"
                variant="enclosed"
                size="sm"
                isLazy
                index={videoSubTab === "generate" ? 0 : 1}
                onChange={(idx) => {
                  const v = idx === 0 ? "generate" : "rendered";
                  setVideoSubTab(v);
                }}
              >
                <Flex justify="space-between" px={[2, 2, 4]} pt={[2, 2, 3]}>
                  <TabList gap="10px">
                    <Tab>
                      Create New
                    </Tab>
                    <Tab>
                      Output Library
                    </Tab>
                  </TabList>
                </Flex>

                <TabPanels>
                  {/* === Generate === */}
                  <TabPanel p={0}>
                    <Flex
                      direction="column"
                      alignItems="center"
                      justifyContent="space-between"
                      p={[4, 6, 10]}
                      width="100%"
                      gap={[6, 8, 10]}
                    >
                      {/* Row of video with captions (kept as-is) */}
                      <Flex gap={[6, 10, 20]} width="100%" justifyContent="center" flexWrap="wrap">
                        <Flex
                          direction="column"
                          align="center"
                          gap={4}
                          flex="1 1 300px"
                          maxW="380px"
                          borderColor="brand.800"
                          border="1px solid"
                          p={[4, 4]}
                          borderRadius="7%"
                        >
                          <Flex
                            justify="center"
                            alignItems="center"
                            width="100%"
                            maxW="330px"
                            style={{ aspectRatio: 1 }}
                            overflow="hidden"
                          >
                            <Image
                              src="/AI_Video_Change.gif"
                              alt="Product video gif"
                              width="100%"
                              height="100%"
                              borderRadius="10px"
                            />
                          </Flex>
                          <Flex direction="column" gap={1}>
                            <Flex direction="column" gap={1}>
                              <Text fontSize="md" fontWeight="bold">
                               URL to Video
                              </Text>
                              <Text fontSize="12px">
                                Turn any product page URL into ready-to-use video ads in seconds with AI.
                              </Text>
                              <Flex justify="center" width="100%" mt={2}>
                                <Button
                                  width="150px"
                                  size="sm"
                                  isDisabled={isError}
                                  isLoading={isRemainingCredsLoading}
                                  colorScheme="brand"
                                  onClick={() => handleMediaTypeChange("video", "product")}
                                >
                                  Start
                                </Button>
                              </Flex>
                              {isError && (
                                  <Text fontSize="14px" textAlign="center" color="red.500">
                                    We’re making some updates. Service will resume shortly. Thanks for your patience!
                                  </Text>
                              )}
                            </Flex>
                          </Flex>
                        </Flex>
                      </Flex>
                    </Flex>
                  </TabPanel>

                  {/* === Output Rendered === */}
                  <TabPanel p={[4, 6, 8]}>
                    <Box>
                      <OutputGenerated />    
                    </Box>
                  </TabPanel>
                </TabPanels>
              </Tabs>
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Box>

      {/* Upload Image Modal */}
      <Modal
        size="6xl"
        isCentered
        isOpen={isImageModalOpen}
        scrollBehavior="inside"
        onClose={onImageModalClose}
        closeOnOverlayClick={false}
        closeOnEsc={false}
      >
        <ModalOverlay />
        <ModalContent>
          <UploadImageModal
            // imageUsageData={imageUsage}
            onSuccess={handleUploadSuccess}
            isOpen={isImageModalOpen}
            onClose={() => {
              onImageModalClose();
              // imageUsageRefetch();
            }}
          />
        </ModalContent>
      </Modal>

      {/* Upload Video Modal */}
      <Modal
        size="6xl"
        isCentered
        isOpen={isVideoModalOpen}
        scrollBehavior="inside"
        onClose={onVideoModalClose}
        closeOnOverlayClick={false}
        closeOnEsc={false}
      >
        <ModalOverlay />
        <ModalContent>
          {videoType === "product" ? (
            <UploadVideoProductModal
              onSuccess={handleUploadSuccess}
              // videoUsageData={videoUsage}
              isOpen={isVideoModalOpen}
              onClose={() => {
                onVideoModalClose();
                // videoUsageRefetch();
              }}
            />
          ) : (
            <UploadVideoAvatarModal
              onSuccess={handleUploadSuccess}
              isOpen={isVideoModalOpen}
              onClose={() => {
                onVideoModalClose();
              }}
            />
          )}
        </ModalContent>
      </Modal>
    </SidebarWithHeader>
  );
}

export default AiHub;
